import { Header } from '@/components/Layout/Header/Header';

const Gifts = () => {
  return (
    <div className="flex flex-col max-h-screen">
      <Header title="Cadeaux" userName="Mas Aly" role="Admin" />
    </div>
  );
};

export default Gifts;
